import React, { Component } from 'react'
import Modal from 'react-modal'
import RepaymentChargeAmountModalUI from './RepaymentChargeAmountModalUI.js'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'

class RepaymentChargeAmountModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      // dueDate: '',
      // dueDateError: null,
      chargeAmount: '',
      chargeAmountError: null,
      chargeRemarks: '',
      chargeRemarksError: null,
      chargeType: '',
      chargeTypeError: null,
      chargeTypeList: [],
      chargeStartDate:'',
      chargeStartDateError:null,
      chargeEndDate:'',
      chargeEndDateError:null,
    }
  }

  componentDidMount() {
    Modal.setAppElement('body')
    const chargeTypeList = [
      { key: 'default_interest', value: 'Penal Charge' },
      { key: 'interest_on_overdue_interest', value: 'Interest on Overdue Interest' },
      { key: 'interest_on_overdue_principal', value: 'Interest on Overdue Principal' },
    ]
    this.setState({ chargeTypeList })
  }

  render() {
    return (
      <RepaymentChargeAmountModalUI
        context={this.props.context}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={this.setErrorList}
        updateMode={this.props.updateMode}
        onCancelClick={this.onCancelClick}
        submitted={this.state.submitted}
        onSubmit={this.onSubmit}
        // Fields
        // dueDate={this.state.dueDate}
        // onDueDateChange={(selectedDateISO) => { this.setState({ dueDate: selectedDateISO }) }}
        // dueDateError={this.state.dueDateError}
        // setDueDateError={(error) => { this.setState({ dueDateError: error }) }}
        
        chargeAmount={this.state.chargeAmount}
        onChargeAmountChange={(event) => { this.setState({ chargeAmount: event.target.value }) }}
        chargeAmountError={this.state.chargeAmountError}
        setChargeAmountError={(error) => { this.setState({ chargeAmountError: error }) }}
        
        chargeRemarks={this.state.chargeRemarks}
        onChargeRemarksChange={(event) => { this.setState({ chargeRemarks: event.target.value }) }}
        chargeRemarksError={this.state.chargeRemarksError}
        setChargeRemarksError={(error) => { this.setState({ chargeRemarksError: error }) }}
        
        chargeType={this.state.chargeType}
        onChargeTypeChange={(event) => { this.setState({ chargeType: event.target.value }) }}
        chargeTypeError={this.state.chargeTypeError}
        setChargeTypeError={(error) => this.setState({ chargeTypeError: error })}
        
        chargeTypeList={this.state.chargeTypeList}

        chargeStartDate={this.state.chargeStartDate}
        onChargeStartDateChange={(selectedDateISO) => { this.setState({ chargeStartDate: selectedDateISO }) }}
        chargeStartDateError={this.state.chargeStartDateError}
        setChargeStartDateError={(error) => { this.setState({ chargeStartDateError: error }) }}

        chargeEndDate={this.state.chargeEndDate}
        onChargeEndDateChange={(selectedDateISO) => { this.setState({ chargeEndDate: selectedDateISO }) }}
        chargeEndDateError={this.state.chargeEndDateError}
        setChargeEndDateError={(error) => this.setState({ chargeEndDateError: error })}
        
        
      />
    )
  }

  onSubmit = () => {

    if (this.state.submitted) return

    this.setState({ submitted: true, successMsg: null, errorList: [] })

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/repayments/scheduledDates/${this.props.selectedRepayment.scheduledDateISO}/chargeAmounts`,
      this.onSubmitCallback,
      {
        chargeType: this.state.chargeType,
        // dueDateISO: this.state.dueDate,
        chargeAmountF: this.state.chargeAmount,
        remarks: this.state.chargeRemarks,
        chargeStartDateISO: this.state.chargeStartDate,
        chargeEndDateISO: this.state.chargeEndDate
      }
    )
  }

  onCancelClick = () => {
    this.setState(
      {
        chargeType: '',
        // dueDate: '',
        chargeAmount: '',
        chargeRemarks: '',
        chargeStartDate:'',
        chargeEndDate: ''
      }
    )
    this.props.onCancelClick();
  }
  onSubmitCallback = (response) => {
    const errorList = response.errorList.map(error => error.message)

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
        this.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 100)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default RepaymentChargeAmountModalSF
